import React from 'react';
import Card from '../ui/Card';
import { DashboardFilters } from '../../pages/Dashboard';
const allSchemes = [{
  name: 'Visa',
  logo: 'https://cdn.magicpatterns.com/uploads/ajjUzt6ZA31HENtrC6smhX/Visa_Logo.png',
  baseTxns: 29901,
  baseValue: 4.4,
  avgTicket: 14715,
  success: 99.1
}, {
  name: 'MasterCard',
  logo: 'https://cdn.magicpatterns.com/uploads/o4mhjVxt1YvUBCyPQMrSjj/MasterCard_Logo.png',
  baseTxns: 23920,
  baseValue: 3.5,
  avgTicket: 14632,
  success: 98.8
}, {
  name: 'PayPak',
  logo: 'https://cdn.magicpatterns.com/uploads/44SLYYjfKQTV8r3NQG1zpK/PayPak_Logo.png',
  baseTxns: 17086,
  baseValue: 2.5,
  avgTicket: 14631,
  success: 97.5
}, {
  name: 'UnionPay',
  logo: 'https://cdn.magicpatterns.com/uploads/uXMvALLn5Yv7B4FKaBwEcf/UnionPay_Logo.png',
  baseTxns: 8543,
  baseValue: 1.2,
  avgTicket: 14046,
  success: 98.2
}, {
  name: 'RAAST',
  logo: 'https://cdn.magicpatterns.com/uploads/fiLiifU998HKz2FF7RhHiq/RAAST_Logo.png',
  baseTxns: 5982,
  baseValue: 0.9,
  avgTicket: 15045,
  success: 99.5
}];
const timeMultipliers = {
  Today: 1,
  Week: 7,
  MTD: 22,
  YTD: 265
};
const channelMultipliers: Record<string, number> = {
  'All Channels': 1,
  POS: 0.45,
  'E-commerce': 0.35,
  'RAAST QR': 0.2
};
interface SchemePerformanceProps {
  filters: DashboardFilters;
}
export const SchemePerformance: React.FC<SchemePerformanceProps> = ({
  filters
}) => {
  const {
    timeRange,
    scheme,
    channel
  } = filters;
  const timeMult = timeMultipliers[timeRange];
  const channelMult = channelMultipliers[channel];
  const filteredSchemes = scheme === 'All Schemes' ? allSchemes : allSchemes.filter(s => s.name === scheme);
  const schemes = filteredSchemes.map(s => {
    const txns = Math.round(s.baseTxns * timeMult * channelMult);
    const value = s.baseValue * timeMult * channelMult;
    return {
      name: s.name,
      logo: s.logo,
      txns: txns.toLocaleString(),
      value: value >= 1 ? `PKR ${value.toFixed(1)}B` : `PKR ${(value * 1000).toFixed(0)}M`,
      avgTicket: `PKR ${Math.round(s.avgTicket * (0.95 + channelMult * 0.1)).toLocaleString()}`,
      success: s.success
    };
  });
  return <Card title="Scheme Performance" className="h-full" data-id="element-232">
      <div className="overflow-x-auto rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm" data-id="element-233">
        <table className="min-w-full divide-y divide-slate-200 dark:divide-slate-700" data-id="element-234">
          <thead className="bg-slate-50 dark:bg-slate-800/80" data-id="element-235">
            <tr data-id="element-236">
              <th scope="col" className="px-5 py-4 text-left text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider" data-id="element-237">
                Scheme
              </th>
              <th scope="col" className="px-5 py-4 text-right text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider" data-id="element-238">
                Transactions
              </th>
              <th scope="col" className="px-5 py-4 text-right text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider" data-id="element-239">
                Value
              </th>
              <th scope="col" className="px-5 py-4 text-right text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider" data-id="element-240">
                Avg Ticket
              </th>
              <th scope="col" className="px-5 py-4 text-right text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider" data-id="element-241">
                Success
              </th>
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-slate-800 divide-y divide-slate-100 dark:divide-slate-700/50" data-id="element-242">
            {schemes.map(s => <tr key={s.name} className="hover:bg-slate-50 dark:hover:bg-slate-700/30 transition-colors group" data-id="element-243">
                <td className="px-5 py-4 whitespace-nowrap" data-id="element-244">
                  <div className="flex items-center space-x-4" data-id="element-245">
                    <div className="w-12 h-8 flex items-center justify-center bg-white rounded-md border border-slate-200 shadow-sm p-1 group-hover:shadow transition-shadow" data-id="element-246">
                      <img src={s.logo} alt={s.name} className="max-h-full max-w-full object-contain" data-id="element-247" />
                    </div>
                    <span className="text-sm font-bold text-slate-900 dark:text-white" data-id="element-248">
                      {s.name}
                    </span>
                  </div>
                </td>
                <td className="px-5 py-4 whitespace-nowrap text-sm font-medium text-slate-600 dark:text-slate-400 text-right" data-id="element-249">
                  {s.txns}
                </td>
                <td className="px-5 py-4 whitespace-nowrap text-sm font-bold text-slate-900 dark:text-white text-right" data-id="element-250">
                  {s.value}
                </td>
                <td className="px-5 py-4 whitespace-nowrap text-sm font-medium text-slate-600 dark:text-slate-400 text-right" data-id="element-251">
                  {s.avgTicket}
                </td>
                <td className="px-5 py-4 whitespace-nowrap text-right" data-id="element-252">
                  <span className={`inline-flex items-center px-2.5 py-1 rounded-md text-xs font-bold ${s.success >= 99 ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400' : s.success >= 98 ? 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400' : 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400'}`} data-id="element-253">
                    {s.success}%
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </Card>;
};